/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Phone_LabelInputs */

const es_l7_phone_label = /** @type {(inputs: L7_Phone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Tienes dudas? Llámanos`)
};

const gl_l7_phone_label = /** @type {(inputs: L7_Phone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes dúbidas? Chámanos`)
};

const en_l7_phone_label = /** @type {(inputs: L7_Phone_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions? Call us`)
};

/**
* | output |
* | --- |
* | "Questions? Call us" |
*
* @param {L7_Phone_LabelInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_phone_label = /** @type {((inputs?: L7_Phone_LabelInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Phone_LabelInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_phone_label(inputs)
	if (locale === "en") return en_l7_phone_label(inputs)
	return es_l7_phone_label(inputs)
});